import { addBooking, addPayment, deleteBookingById, deletePaymentById, getAllBooking, getBookingById, getPaymentByBookingId, updateBooking, updateBookingStatus } from "../../../helpers/backend_helper";
import { fuelRequest } from "../Fuel/reducer";
import { bookingError, bookingRequest, bookingSuccess, getBookingByIdError, getBookingByIdRequest, getBookingByIdSuccess, paymentEditSuccess, paymentError, paymentRequest, paymentSuccess } from "./reducer";

export const fetchBooking = (page:number,count:number,keyword:string,status:string,driverId?:string,startDate?:number,endDate?:number) => async (dispatch: any) => {
    dispatch(bookingRequest());
    try {
      const response: any = await getAllBooking(page,count,keyword,status,driverId,startDate,endDate);
      if (response && response.isSuccess) {
        dispatch(bookingSuccess(response.data));
        return response
      } else {
        dispatch(bookingError("Failed to fetch Booking"));
        return response
      }
    } catch (error: any) {
      dispatch(bookingError(error.message));
      return null
    }
  };

 export const addNewBooking = (data: any) => async (dispatch: any) => {
    dispatch(bookingRequest());
    try {
      const response: any = await addBooking(data);
      if (response && response.data) {
        dispatch(bookingSuccess(response.data));
        return response 
      } else {
        dispatch(bookingError("Failed to add booking"));
      }
    } catch (error: any) {
      dispatch(bookingError(error.message));
    }
  };
  
  export const editBooking = (data: any) => async (dispatch: any) => {
    dispatch(bookingRequest());
    try {
      const response: any = await updateBooking(data);
      if (response.data && response.isSuccess) {
        dispatch(bookingSuccess(response));
        return response 
      } else {
        dispatch(bookingError("Failed to edit maintenance"));
        return response 
      }
    } catch (error: any) {
      dispatch(bookingError(error.message));
      return null
    }
  };
 
  export const fetchBookingById = (id: string) => async (dispatch: any) => {
    dispatch(getBookingByIdRequest());
    try {
      const response: any = await getBookingById(id);  
  
      if (response && response.isSuccess) {
        dispatch(getBookingByIdSuccess(response.data)); 
        return response;  
      } else {
        dispatch(getBookingByIdError("Failed to fetch Fuel by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(getBookingByIdError(error.message));  
      return null;
    }
  };    

  export const deleteBooking = (bookingId: string) => async (dispatch: any) => {
    dispatch(bookingRequest());
    try {
      const response: any = await deleteBookingById(bookingId);  
      if (response && response.isSuccess) {
        dispatch(bookingSuccess(response.data)); 
        return response;  
      } else {
        dispatch(bookingError("Failed to fetch Fuel by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(bookingError(error.message));  
      return null;
    }
  }

export const addNewPayment = (data: any) => async (dispatch: any) => {
  dispatch(paymentRequest());
  try {
    const response: any = await addPayment(data);
    if (response && response.isSuccess) {
      dispatch(paymentSuccess(response.data));
      return response; 
    } else {
      dispatch(paymentError("Failed to add payment"));
      return null; 
    }
  } catch (error: any) {
    dispatch(paymentError(error.message));  
    return null;
  }  
}

// export const editPayment = (data: any) => async (dispatch: any) => {
//   dispatch(paymentRequest());
//   try {
//     const response: any = await addPayment(data);
//     if (response && response.isSuccess) {
//       dispatch(paymentEditSuccess(response.data));
//       return response; 
//     } else {
//       dispatch(paymentError("Failed to edit payment"));
//       return null; 
//     }
//   } catch (error: any) {
//     dispatch(paymentError(error.message));  
//     return null;
//   }  
// }

export const removePayment = (paymentId: string) => async (dispatch: any) => {
  dispatch(paymentRequest());
  try {
    const response: any = await deletePaymentById(paymentId);  
    if (response && response.isSuccess) {
      dispatch(paymentSuccess(response.data)); 
      return response;  
    } else {
      dispatch(paymentError("Failed to fetch Fuel by ID"));
      return null; 
    }
  } catch (error: any) {
    dispatch(paymentError(error.message));  
    return null;
  }
}
export const fetchPaymentById = (id: string) => async (dispatch: any) => {
  dispatch(getBookingByIdRequest());
  try {
    const response: any = await getPaymentByBookingId(id);  
    if (response && response?.isSuccess) {
      dispatch(getBookingByIdSuccess(response?.data)); 
      return response;  
    } else {
      dispatch(getBookingByIdError("Failed to fetch Fuel by ID"));
      return null; 
    }
  } catch (error: any) {
    dispatch(getBookingByIdError(error?.message));  
    return null;
  }
}
export const updateTripStatus = (bookingId: string, tripStatus: string) => async (dispatch: any) => {
  dispatch(bookingRequest());
  try {
    const response: any = await updateBookingStatus( bookingId, tripStatus );
    if (response && response.isSuccess) {
      dispatch(bookingSuccess(response.data));
      return response
    } else {
      dispatch(bookingError("Failed to update status"));
      return response
    }
  } catch (error: any) {
    dispatch(bookingError(error.message));
    return null
  }
}